import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { EmptySection } from "../../../../components/sections/empty/Empty";
import { LoaderSection } from "../../../../components/sections/loader/Loader";
import { getVoteRequestById } from "../../../../services/voteQuestionSvc";

export const VoteReqViewPage = () => {
  const { requestId } = useParams<{ requestId: string }>();

  const { data: voteRequest, isLoading } = useQuery(
    ["getVoteRequestById", requestId],
    () => getVoteRequestById(requestId),
    { enabled: !!requestId }
  );

  if (isLoading) return <LoaderSection height={"50vh"} />;
  if (!voteRequest?.data) return <EmptySection height={"50vh"} />;

  const { user, category, answers } = voteRequest.data;

  return (
    <div className="mt-4">
      <div className="card mb-4">
        <div className="card-header">
          <h5 className="card-title">Foydalanuvchi ma'lumotlari</h5>
        </div>
        <div className="card-body">
          <p>
            <strong>Ism:</strong> {user.first_name} {user.last_name}
          </p>
          <p>
            <strong>Telefon:</strong> {user.phone}
          </p>
          <p>
            <strong>Roli:</strong> {user.role}
          </p>
          <p>
            <strong>Vaqti:</strong> {new Date(user.created_at).toLocaleString()}
          </p>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-header">
          <h5 className="card-title">So'rovnoma ma'lumotlari</h5>
        </div>
        <div className="card-body">
          <p>
            <strong>Sarlavha:</strong> {category.title}
          </p>
          <p>
            <strong>Tavsif:</strong> {category.description}
          </p>
          <p>
            <strong>Vaqti:</strong>{" "}
            {new Date(category.created_at).toLocaleString()}
          </p>
        </div>
      </div>

      <div className="card mb-10">
        <div className="card-header">
          <h5 className="card-title">Javoblar</h5>
        </div>
        <div className="card-body">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Savol</th>
                <th>Javob</th>
                <th>Vaqti</th>
              </tr>
            </thead>
            <tbody>
              {answers.map((answer, index) => (
                <tr key={answer.id}>
                  <td>{index + 1}</td>
                  <td>{answer.questionnaire.question}</td>
                  <td>{answer.answer.answer || "Javob yo'q"}</td>
                  <td>{new Date(answer.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
